<template>
  <div
    class="tab-pane fade show active"
    id="pills-2"
    role="tabpanel"
    aria-labelledby="pills-2-tab"
  >
    <div class="tourn-banner my-4">
      <div class="card flex-md-row justify-content-md-between">
        <div class="col-md-4 card-img-wrapper order-md-2">
          <!-- <img
            :src="
              tournamentinfo.tourbinary &&
              tournamentinfo.tourbinary[0] &&
              tournamentinfo.tourbinary[0].filepath_web
                | get_img(
                      'https://hojustorage.s3.ap-southeast-2.amazonaws.com/files/tournament/06edda88fe1bb993db760ee25b8ad9fa.jpg'
                    )
            "
          /> -->
          <div class="image"
            :style="{
                backgroundImage: `url(${
                    (tournamentinfo.tourbinary &&
                    tournamentinfo.tourbinary[0] &&
                    tournamentinfo.tourbinary[0].filepath_web)
                    ? $options.filters.get_img(tournamentinfo.tourbinary[0].filepath_web)
                    : 'https://hojustorage.s3.ap-southeast-2.amazonaws.com/files/tournament/06edda88fe1bb993db760ee25b8ad9fa.jpg'
                })`
            }">
          </div>
        </div>

        <div class="col-md-8 d-flex flex-column order-md-1">
          <div class="card-body">
            <p class="badge-group">
              <span class="badge tourn-type">
                {{ tournament_type(tournamentinfo.tourtype_fk) }}
              </span>
              <span class="badge tourn-game-type">
                {{ game_type(tournamentinfo.gametype_fk) }}
              </span>
            </p>
            <h3 class="tourn-title line-clamp-clear">
              {{ tournamentinfo.title }}
            </h3>
            <p class="tourn-rank-type">
              <!-- {{ game_type(tournamentinfo.gametype_fk) }} <strong>&middot;</strong>  -->
              {{ tournamentinfo.tour_rank_type | tour_rank_type }}
            </p>
          </div>

          <div class="card-footer">
            <div class="row gx-2 gy-1">
              <div
                class="col-auto text-date"
                v-if="
                  tournamentinfo.timezone_startdate &&
                  tournamentinfo.timezone_startdate.timezone_private
                "
              >
                <!-- 사용자 시간 -->
                <dfn
                  class="time-zone-mark badge rounded-pill bg-orange"
                  title="Connect time"
                  >CT</dfn
                >
                {{
                  tournamentinfo.timezone_startdate &&
                  tournamentinfo.timezone_startdate.timezone_private
                    | dateformat
                }}
                ~
                {{
                  tournamentinfo.timezone_startdate &&
                  tournamentinfo.timezone_enddate.timezone_private | dateformat
                }}
              </div>
              <div
                class="col-auto text-date"
                v-else-if="
                  tournamentinfo.timezone_startdate &&
                  tournamentinfo.timezone_startdate.timezone_common
                "
              >
                <!-- 서비스 시간 -->
                <dfn
                  class="time-zone-mark badge rounded-pill bg-green"
                  title="Standard time"
                  >ST</dfn
                >
                {{
                  tournamentinfo.timezone_startdate &&
                  tournamentinfo.timezone_startdate.timezone_common | dateformat
                }}
                ~
                {{
                  tournamentinfo.timezone_startdate &&
                  tournamentinfo.timezone_enddate.timezone_common | dateformat
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <p
      class="pt-1 text-subscript text-info"
      v-if="tournamentinfo.gametype_fk == 9"
    >
      <span class="material-icons-outlined">info</span>
      {{ $t("text.common.offline_scramble_txt") }}
    </p>

    <b-form
      @submit="onSubmit"
      class="filter-group row row-cols-2 row-cols-sm-auto g-2 justify-content-end mt-3"
      v-if="tournamentinfo.gametype_fk == 1"
    >
      <div class="col">
        <select aria-label="" v-model="searchData.pagesize">
          <option value="10" selected>
            {{ $t("filter.common.sort_by_10") }}
          </option>
          <option value="50">{{ $t("filter.common.sort_by_50") }}</option>
          <option value="100">
            {{ $t("filter.common.sort_by_100") }}
          </option>
        </select>
      </div>

      <div class="col" v-if="tournamentinfo.tour_rank_type == '0'">
        <div class="input-group">
          <select
            class="form-select"
            aria-label="Select one"
            v-model="searchData.tour_rank_type"
          >
            <option value="1">
              {{ $t("filter.common.low_gross") }}
            </option>
            <option value="2">
              {{ $t("filter.common.low_net") }}
            </option>
          </select>
        </div>
      </div>

      <div class="col flex-grow-1 flex-sm-grow-0">
        <div class="input-group">
          <select
            class="form-select"
            aria-label="Select one"
            name="gender"
            v-model="searchData.gender"
          >
            <option value="0" :selected="searchData.gender === 0">
              {{ $t("filter.common.total") }}
            </option>
            <option value="1" :selected="searchData.gender === 1">
              {{ $t("filter.common.male") }}
            </option>
            <option value="2" :selected="searchData.gender === 2">
              {{ $t("filter.common.female") }}
            </option>
          </select>
          <button
            class="btn btn-primary btn-md icon-search"
            type="submit"
          ></button>
        </div>
      </div>
      <!-- <div class="col flex-fill">
        <ul class="tab-sub">
          <li
            v-if="
              tournamentinfo.tour_rank_type == 1 ||
              tournamentinfo.tour_rank_type == 0
            "
          >
            <a class="on">{{ $t("button.common.stroke") }}</a>
          </li>
          <li v-if="tournamentinfo.tour_rank_type == 2">
            <a class="on">{{ $t("button.common.stroke_handicap") }}</a>
          </li>
        </ul>
      </div> -->
    </b-form>

    <table class="table board" v-if="tournamentinfo.gametype_fk == 1">
      <thead>
        <tr
          v-if="
            (tournamentinfo.tour_rank_type == '0' &&
              searchData.tour_rank_type == '1') ||
            tournamentinfo.tour_rank_type == '1'
          "
        >
          <th class="d-lg-table-cell">
            {{ $t("title.common.ranking") }}
          </th>
          <th class="d-lg-table-cell">
            {{ $t("title.common.nickname") }}
          </th>
          <th class="d-none d-lg-table-cell">
            {{ $t("title.common.location") }}
          </th>
          <th class="d-none d-lg-table-cell">
            {{ $t("title.common.course") }}
          </th>
          <th class="d-none d-sm-table-cell">
            {{ $t("title.common.stroke_score") }}
          </th>
          <th class="d-none d-lg-table-cell">
            {{ $t("title.common.no_of_play") }}
          </th>
          <th class="col-auto d-none d-lg-table-cell">
            {{ $t("title.common.standard_point") }}
          </th>
          <th
            class="col-auto d-none d-lg-table-cell"
            v-if="tournamentinfo.oom_point != 0"
          >
            {{ $t("title.common.oom_point") }}
          </th>
          <th class="th-arrow"></th>
        </tr>
        <tr
          v-if="
            (tournamentinfo.tour_rank_type == '0' &&
              searchData.tour_rank_type == '2') ||
            tournamentinfo.tour_rank_type == '2'
          "
        >
          <th class="d-lg-table-cell">
            {{ $t("title.common.ranking") }}
          </th>
          <th class="d-lg-table-cell">
            {{ $t("title.common.nickname") }}
          </th>
          <th class="d-none d-lg-table-cell">
            {{ $t("title.common.location") }}
          </th>
          <th class="d-none d-lg-table-cell">
            {{ $t("title.common.course") }}
          </th>
          <th class="d-none d-sm-table-cell">
            {{ $t("title.common.low_net_score") }}<br /><span class="text-blue"
              >({{ $t("title.common.handi_score") }})</span
            >
          </th>
          <th class="d-none d-lg-table-cell">
            {{ $t("title.common.no_of_play") }}
          </th>
          <th class="col-auto d-none d-lg-table-cell">
            {{ $t("title.common.standard_point") }}
          </th>

          <th
            class="col-auto d-none d-lg-table-cell"
            v-if="tournamentinfo.oom_point != 0"
          >
            {{ $t("title.common.oom_point") }}
          </th>
          <!-- <th class="d-none d-lg-table-cell">
              Final Score<br />(Correction value)
            </th> -->
          <th class="th-arrow"></th>
        </tr>
      </thead>

      <tbody
        v-if="
          (total_cnt > 0 &&
            tournamentinfo.tour_rank_type == '0' &&
            searchData.tour_rank_type == '1') ||
          (total_cnt > 0 && tournamentinfo.tour_rank_type == '1')
        "
      >
        <template v-for="(item, index) in items">
          <tr :key="index">
            <td class="d-lg-table-cell">
              <strong class="text-black">{{
                item.tournamentrankinfo.rank
              }}</strong>
            </td>
            <td class="d-lg-table-cell text-start">
              <MemberInfo
                :nickname="item.tournamentrankinfo.nickname"
                :playerno="item.tournamentrankinfo.playerno"
                :member_img="item.tournamentrankinfo.member_img"
                :badge_img="item.tournamentrankinfo.badge_img"
              />
            </td>
            <td class="d-none d-lg-table-cell shop-name">
              {{
                item.tournamentrankinfo.shopinfo &&
                item.tournamentrankinfo.shopinfo.shopname
              }}
            </td>
            <td class="d-none d-lg-table-cell">
              <template v-for="(course, index_n) in item.coursescore">
                <p :key="index_n + 'l1'">
                  {{ course.coursename }}
                </p>
              </template>
            </td>
            <td class="d-none d-sm-table-cell">
              <template v-for="(course, index_n) in item.coursescore">
                <p :key="index_n + 'l1'">
                  {{ course.strokescore }}
                </p>
              </template>
            </td>
            <td class="d-none d-lg-table-cell text-red">
              {{ item.tournamentrankinfo.entrycnt | comma }}
              / {{ item.tournamentrankinfo.entrylimit | transToValue("∞") }}
            </td>
            <td class="col-auto d-none d-lg-table-cell text-point-sp">
              {{
                item.tournamentrankinfo.standard_points | comma | suffix("P")
              }}
            </td>

            <td
              class="col-auto d-none d-lg-table-cell text-point-op"
              v-if="tournamentinfo.oom_point != 0"
            >
              {{ item.tournamentrankinfo.oom_points | comma | suffix("P") }}
            </td>
            <td class="td-arrow" @click="toggle_tr(index)">
              <img
                src="/img/arrow_none_collapsed.png"
                :class="{ 'btn-toggle-arrow': view_hide === index }"
              />
            </td>
          </tr>
          <tr
            class="d-lg-none"
            :class="{ show: view_hide === index }"
            :key="index + 'r'"
            v-if="view_hide === index"
          >
            <td colspan="8">
              <div class="toggle-content">
                <div class="row">
                  <div class="col-4">
                    {{ $t("title.common.location") }}
                  </div>
                  <div class="col-8 shop-name">
                    {{
                      item.tournamentrankinfo.shopinfo &&
                      item.tournamentrankinfo.shopinfo.shopname
                    }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">
                    {{ $t("title.common.course") }}
                  </div>
                  <div class="col-8">
                    <template v-for="(course, index_nm) in item.coursescore">
                      {{ index_nm > 0 ? " / " : "" }}
                      <span :key="index_nm + 'm'"
                        >{{ course.coursename }}
                      </span>
                    </template>
                  </div>
                </div>

                <div class="row d-sm-none">
                  <div class="col-4">{{ $t("title.common.stroke_score") }}</div>
                  <div class="col-8">
                    <template v-for="(course, index_nm) in item.coursescore">
                      {{ index_nm > 0 ? " / " : "" }}
                      <span :key="index_nm + 'm'">
                        {{ course.strokescore }}</span
                      >
                    </template>
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">{{ $t("title.common.no_of_play") }}</div>
                  <div class="col-8 text-red">
                    {{ item.tournamentrankinfo.entrycnt | comma }}
                    /
                    {{ item.tournamentrankinfo.entrylimit | transToValue("∞") }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">
                    {{ $t("title.common.standard_point") }}
                  </div>
                  <div class="col-8 text-point-sp">
                    {{
                      item.tournamentrankinfo.standard_points
                        | comma
                        | suffix("P")
                    }}
                  </div>
                </div>

                <div class="row" v-if="tournamentinfo.oom_point != 0">
                  <div class="col-4">
                    {{ $t("title.common.oom_point") }}
                  </div>
                  <div class="col-8 text-point-op">
                    {{
                      item.tournamentrankinfo.oom_points | comma | suffix("P")
                    }}
                  </div>
                </div>
                <!-- <div class="row">
                    <div class="col-4">Final Score<br />(Correction value)</div>
                    <div class="col-8">
                      {{ item.tournamentrankinfo.newperiolastscore | comma }}
                    </div>
                  </div> -->
              </div>
            </td>
          </tr>
        </template>
      </tbody>

      <tbody
        v-else-if="
          (total_cnt > 0 &&
            tournamentinfo.tour_rank_type == '0' &&
            searchData.tour_rank_type == '2') ||
          (total_cnt > 0 && tournamentinfo.tour_rank_type == '2')
        "
      >
        <template v-for="(item, index) in items">
          <tr :key="index">
            <td class="d-lg-table-cell">
              <strong class="text-black">{{
                item.tournamentrankinfo.rank
              }}</strong>
            </td>
            <td class="d-lg-table-cell text-start">
              <MemberInfo
                :nickname="item.tournamentrankinfo.nickname"
                :playerno="item.tournamentrankinfo.playerno"
                :member_img="item.tournamentrankinfo.member_img"
                :badge_img="item.tournamentrankinfo.badge_img"
              />
            </td>
            <td class="d-none d-lg-table-cell shop-name">
              {{
                item.tournamentrankinfo.shopinfo &&
                item.tournamentrankinfo.shopinfo.shopname
              }}
            </td>
            <td class="d-none d-lg-table-cell">
              <template v-for="(course, index_n) in item.coursescore">
                <p :key="index_n + 'l1'">
                  {{ course.coursename }}
                </p>
              </template>
            </td>

            <td class="d-none d-sm-table-cell">
              <template v-for="(course, index_n) in item.coursescore">
                <p :key="index_n + 'l1'">
                  {{ course.low_net }} (<span class="text-blue">{{
                    hc_au(item.tournamentrankinfo.handicap_diff)
                  }}</span
                  >)
                </p>
              </template>
            </td>

            <td class="d-none d-lg-table-cell text-red">
              {{ item.tournamentrankinfo.entrycnt | comma }} /
              {{ item.tournamentrankinfo.entrylimit | transToValue("∞") }}
            </td>
            <td class="col-auto d-none d-lg-table-cell text-point-sp">
              {{
                item.tournamentrankinfo.standard_points | comma | suffix("P")
              }}
            </td>
            <td
              class="col-auto d-none d-lg-table-cell text-point-op"
              v-if="tournamentinfo.oom_point != 0"
            >
              {{ item.tournamentrankinfo.oom_points | comma | suffix("P") }}
            </td>
            <!-- <td class="d-none d-lg-table-cell">
                {{ item.tournamentrankinfo.newperiolastscore | comma }}
              </td> -->
            <td class="td-arrow" @click="toggle_tr(index)">
              <img
                src="/img/arrow_none_collapsed.png"
                :class="{ 'btn-toggle-arrow': view_hide === index }"
              />
            </td>
          </tr>
          <tr
            class="d-lg-none"
            :class="{ show: view_hide === index }"
            :key="index + 'r'"
            v-if="view_hide === index"
          >
            <td colspan="8">
              <div class="toggle-content">
                <div class="row">
                  <div class="col-4">
                    {{ $t("title.common.location") }}
                  </div>
                  <div class="col-8 shop-name">
                    {{
                      item.tournamentrankinfo.shopinfo &&
                      item.tournamentrankinfo.shopinfo.shopname
                    }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">
                    {{ $t("title.common.course") }}
                  </div>
                  <div class="col-8">
                    <template v-for="(course, index_n) in item.coursescore">
                      <p :key="index_n + 'l1'">
                        {{ course.coursename }}
                      </p>
                    </template>
                  </div>
                </div>
                <div class="row d-sm-none">
                  <div class="col-4">
                    {{ $t("title.common.low_net_score") }}<br /><span
                      class="text-blue"
                      >({{ $t("title.common.handi_score") }})</span
                    >
                  </div>
                  <div class="col-8">
                    <template v-for="(course, index_n) in item.coursescore">
                      <p :key="index_n + 'l1'">
                        {{ course.low_net }} (<span class="text-blue">{{
                          hc_au(item.tournamentrankinfo.handicap_diff)
                        }}</span
                        >)
                      </p>
                    </template>
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">{{ $t("title.common.no_of_play") }}</div>
                  <div class="col-8 text-red">
                    {{ item.tournamentrankinfo.entrycnt | comma }} /
                    {{ item.tournamentrankinfo.entrylimit | transToValue("∞") }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">
                    {{ $t("title.common.standard_point") }}
                  </div>
                  <div class="col-8 text-point-sp">
                    {{
                      item.tournamentrankinfo.standard_points
                        | comma
                        | suffix("P")
                    }}
                  </div>
                </div>

                <div class="row" v-if="tournamentinfo.oom_point != 0">
                  <div class="col-4">
                    {{ $t("title.common.oom_point") }}
                  </div>
                  <div class="col-8 text-point-op">
                    {{
                      item.tournamentrankinfo.oom_points | comma | suffix("P")
                    }}
                  </div>
                </div>
                <!-- <div class="row">
                    <div class="col-4">Final Score<br />(Correction value)</div>
                    <div class="col-8">
                      {{ item.tournamentrankinfo.newperiolastscore | comma }}
                    </div>
                  </div> -->
              </div>
            </td>
          </tr>
        </template>
      </tbody>

      <tbody v-else>
        <tr>
          <td
            colspan="10"
            v-if="tournamentinfo.holecount > 9 || searchData.scoretype < 3"
          >
            {{ $t("text.common.no_data") }}
          </td>
          <td colspan="10" v-else>
            {{ $t("text.common.not_provided_9_hole_mode") }}
          </td>
        </tr>
      </tbody>
    </table>

    <b-pagination-nav
      :link-gen="linkGen"
      :number-of-pages="page_total"
      v-model="searchData.pageno"
      use-router
      aria-label="Page navigation"
      v-if="page_total > 1"
      first-class="prev"
      prev-class="prev"
      next-class="next"
      last-class="next"
      hide-ellipsis
      limit="10"
    >
      <template #first-text>
        <i class="material-icons">keyboard_double_arrow_left</i>
      </template>
      <template #prev-text>
        <i class="material-icons">navigate_before</i>
      </template>
      <template #next-text>
        <i class="material-icons">navigate_next</i>
      </template>
      <template #last-text>
        <i class="material-icons">keyboard_double_arrow_right</i>
      </template>
      <template #page="{ page, active }">
        <a v-if="active">{{ page }}</a>
        <a v-else>{{ page }}</a>
      </template>
    </b-pagination-nav>

    <b-toast
      id="toast-require-login"
      toaster="position-fixed top-50 start-50 translate-middle"
      no-close-button
      no-auto-hide
      solid
      body-class="p-4 text-center"
    >
      <div class="avatar avatar-lg mt-2 bg-orange border-0">
        <h3 class="material-icons text-white">person</h3>
      </div>
      <h6 class="sub-title mt-3 mb-2">{{ $t("text.common.require_login") }}</h6>
      <p class="pt-1">{{ $t("text.common.go_login_page") }}</p>
      <div class="btn-bottom-wrapper mt-3">
        <b-button
          size="sm"
          variant="outline-secondary"
          :aria-label="$t('button.common.cancel')"
          @click="$bvToast.hide('toast-require-login')"
        >
          {{ $t("button.common.cancel") }}
        </b-button>
        <b-button
          size="sm"
          variant="secondary"
          :aria-label="$t('button.common.login')"
          @click="$router.push('/Login')"
        >
          {{ $t("button.common.login") }}
        </b-button>
      </div>
    </b-toast>
    <b-modal
      id="modal-entry-fee-payment"
      @shown="onModalShown"
      ref="modal-entry-fee-payment"
      size="md"
      centered
      scrollable
      no-close-on-backdrop
      footer-class="btn-bottom-wrapper"
    >
      <template #modal-header>
        <h3>{{ $t("text.common.entry_fee_payment") }}</h3>
        <b-button
          variant="close"
          :aria-label="$t('button.common.close')"
          @click="$bvModal.hide('modal-entry-fee-payment')"
        >
        </b-button>
      </template>
      <template v-if="pay_flag == '1'">
        <p class="modal-subtitle lh-sm">
          {{ paytournamentinfo.tourdefine.title }}
        </p>
        <b-form
          class="row row-cols-sm-auto g-2 justify-content-end"
        >
          <div class="row g-0 table-type header-col p-keep">
            <div class="col-sm-4">
              {{ $t("title.common.player") }}
            </div>
            <div class="col-sm-8">
              <p class="d-flex flex-wrap">
                <strong class="me-1">{{ $t("text.common.id") }}</strong>
                <span>: {{ paytournamentinfo.player.player_id }}</span>
              </p>
              <p class="d-flex flex-wrap mt-1">
                <strong class="me-1">{{ $t("title.common.nickname") }}</strong>
                <span class="text-nickname"
                  >: {{ paytournamentinfo.player.nickname }}</span
                >
              </p>
            </div>

            <div class="col-sm-4">
              {{ $t("title.common.entry_limit") }}
            </div>
            <div class="col-sm-8 text-red">
              {{ paytournamentinfo.tour_results.total_game || 0 }} /
              {{ paytournamentinfo.tourdefine.entrylimit | transToValue("∞") }}
            </div>

            <div class="col-sm-4">
              {{ $t("title.common.product_name") }}
            </div>
            <div class="col-sm-8">
              {{ product.name }}
            </div>

            <div class="col-sm-4">
              {{ $t("title.tournament.description") }}
            </div>
            <div class="col-sm-8">
              {{ product.description }}
            </div>
            <div class="col-sm-4">
              {{ $t("text.common.entry_fee") }}
            </div>
            <template v-if="coupon && coupon.id">
              <div class="col-sm-8">
                <span class="origin-price">
                  {{ product.amount | stripe_unit_amount(product.currency) }}
                </span>
                <span class="text-blue" v-if="coupon.percent_off">
                  {{ coupon.discounted_amount | stripe_unit_amount(product.currency) }}
                   ({{coupon.percent_off }}% off)
                </span>
                <span class="text-blue" v-if="coupon.discounted_amount">
                  {{ coupon.discounted_amount | stripe_unit_amount(product.currency) }}
                   ({{coupon.discounted_amount | stripe_unit_amount(product.currency) }} off)
                </span>
                <p class="text-red fw-500 lh-120 fs-12" v-if="coupon.discounted_amount < 50">
                   Please note: A minimum payment of $0.50 AUD is required even if your total is $0 (after discounts or coupons).
                </p>

              </div>

            </template>
            <div class="col-sm-8" v-else>
              <p>{{ product.amount | stripe_unit_amount(product.currency) }}</p>
            </div>
            <template v-if="product && product.is_promotion">
              <div class="col-sm-4">
                {{ $t("title.common.coupon") }}
              </div>
              <div class="col-sm-8">
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control "
                    :placeholder="$t('title.common.coupon_code')"
                    :aria-label="$t('title.common.coupon_code')"
                    autocomplete="off"
                    v-model="couponCode"
                  />
                  <button
                    class="btn btn-primary btn-md "
                    type="button"
                    id="id"
                    @click="coupon_check(paytournamentinfo.tourdefine && paytournamentinfo.tourdefine.tour_pk)"
                  >
                    {{ $t("button.common.apply") }}
                  </button>
                </div>
              </div>
            </template>

            <div class="col-sm-4">
              {{ $t("text.common.card_info") }}
            </div>
            <div class="col-sm-8">
              <div class="row g-2">
                <div class="col-12" id="card-number-element">
                  <!-- <input
                    type="text"
                    class="form-control"
                    placeholder="1234 1234 1234 1234"
                    :aria-label="$t('text.common.card_number')"
                    name="CardNumber"
                    autocomplete="off"
                  /> -->
                </div>
                <div class="col-6" id="card-expiry-element">
                  <!-- <input
                    type="text"
                    class="form-control"
                    placeholder="MM / YY"
                    :aria-label="$t('text.common.card_expiry')"
                    name="CardExpiry"
                    autocomplete="off"
                  /> -->
                </div>
                <div class="col-6" id="card-cvc-element"></div>
              </div>
            </div>

            <div class="col-sm-4">
              {{ $t("text.common.zip_code") }}
            </div>
            <div class="col-sm-8">
              <div class="row g-2">
                <!-- <div class="col-12">
                  <select name="countryno">
                    <option value="">{{ $t("title.common.choose") }}</option>
                  </select>
                </div> -->
                <div class="col-12">
                  <input
                    type="text"
                    class="form-control text-capitalize"
                    :placeholder="$t('text.common.zip_code')"
                    :aria-label="$t('text.common.zip_code')"
                    name=""
                    autocomplete="off"
                    v-model="postalCode"
                  />
                </div>
              </div>
            </div>
          </div>
        </b-form>
      </template>
      <!-- 결제 정상 완료 -->
      <template v-if="pay_flag == '2'">
        <div class="mt-5 mb-4 text-center">
          <p class="material-icons fs-48 text-success">check_circle</p>
          <h6 class="sub-title my-2 pt-1 text-capitalize">
            {{ $t("text.common.payment_complete") }}
          </h6>
          <p class="pt-1 fs-14 lh-sm">
            {{ $t("text.common.payment_successfully") }}
          </p>
        </div>

        <div class="card">
          <div class="card-body px-3 py-2 fs-14">
            <div class="row g-0 table-type header-col p-keep border-0">
              <div class="col-sm-4 bg-transparent">
                {{ $t("text.common.payment_method") }}
              </div>
              <div class="col-sm-8">
                {{
                  (pay_result.paymentIntent.payment_method_types &&
                    pay_result.paymentIntent.payment_method_types.join(", ")) ||
                  ""
                }}
              </div>

              <div class="col-sm-4 bg-transparent">
                {{ $t("text.common.payment_amount") }}
              </div>
              <div class="col-sm-8">
                {{
                  pay_result.paymentIntent.amount
                    | stripe_unit_amount(pay_result.paymentIntent.currency)
                }}
                <p class="text-red fw-500 lh-120 fs-12" v-if="pay_result.paymentIntent.amount <= 50">
                   Please note: A minimum payment of $0.50 AUD is required even if your total is $0 (after discounts or coupons).
                </p>
              </div>

              <div class="col-sm-4 bg-transparent">
                {{ $t("text.common.payment") }} {{ $t("text.common.number") }}
              </div>
              <div class="col-sm-8">{{ pay_result.paymentIntent.id }}</div>

              <div class="col-sm-4 bg-transparent">
                {{ $t("text.common.date") }}
              </div>
              <div class="col-sm-8 text-date">
                {{ (pay_result.paymentIntent.created * 1000) | dateformat }}
              </div>

              <div class="col-sm-4 bg-transparent">
                {{ $t("text.common.company") }}
              </div>
              <div class="col-sm-8">XGAU</div>
            </div>
          </div>
        </div>
      </template>
      <!-- 참가 제한 초과 -->
      <template v-if="pay_flag == '3'">
        <div class="my-5 text-center">
          <p class="material-icons fs-48 text-orange">report</p>
          <h6 class="sub-title my-2 pt-1 text-capitalize">
            {{ pay_fail_message }}
          </h6>
          <p class="pt-1 fs-14 lh-sm">
            {{ $t("text.common.participate_another_tourn") }}
          </p>
        </div>
      </template>
      <!-- 결제 실패 -->
      <template v-if="pay_flag == '4'">
        <div class="mt-5 mb-4 text-center">
          <p class="material-icons fs-48 text-danger">dangerous</p>
          <h6 class="sub-title my-2 pt-1 text-capitalize">
            {{ $t("text.common.payment_failed") }}
          </h6>
          <p class="pt-1 fs-14 lh-sm">
            {{ $t("text.common.payment_unsuccessful") }}<br />
            {{ $t("text.common.please_try_again") }}
          </p>
        </div>

        <div class="card">
          <div class="card-body px-3 py-2 fs-14">
            <div class="row g-0 table-type header-col p-keep border-0">
              <div class="col-sm-4 bg-transparent">
                {{ $t("text.common.error") }} {{ $t("text.common.code") }}
              </div>
              <div class="col-sm-8">404</div>

              <div class="col-sm-4 bg-transparent">
                {{ $t("text.common.error") }} {{ $t("text.common.reason") }}
              </div>
              <div class="col-sm-8">Card Company Failure</div>
            </div>
          </div>
        </div>
      </template>
      <template #modal-footer>
        <!-- <b-button
          size="md"
          variant="outline-secondary"
          :aria-label="$t('button.common.close')"
          @click="$bvModal.hide('modal-entry-fee-payment')"
        >
          {{ $t("button.common.close") }}
        </b-button> -->

        <!-- <b-button
          size="md"
          variant="outline-secondary"
          :aria-label="$t('button.common.confirm')"
          @click="$bvModal.hide('modal-entry-fee-payment')"
        >
          {{ $t("button.common.confirm") }}
        </b-button> -->

        <b-button
          size="md"
          v-if="pay_flag == '1'"
          variant="outline-secondary"
          :aria-label="$t('button.common.cancel')"
          @click="$bvModal.hide('modal-entry-fee-payment')"
        >
          {{ $t("button.common.cancel") }}
        </b-button>

        <b-button
          size="md"
          v-else-if="pay_flag == '2'"
          variant="outline-secondary"
          :aria-label="$t('button.common.done')"
          @click="$bvModal.hide('modal-entry-fee-payment')"
        >
          {{ $t("button.common.done") }}
        </b-button>

        <b-button
          size="md"
          v-else
          variant="outline-secondary"
          :aria-label="$t('button.common.close')"
          @click="$bvModal.hide('modal-entry-fee-payment')"
        >
          {{ $t("button.common.close") }}
        </b-button>

        <b-button
          v-if="pay_flag == '1'"
          size="md"
          variant="secondary"
          :aria-label="$t('button.common.submit')"
          type="button"
          @click="onPaySubmit"
        >
          {{ $t("button.common.submit") }}
        </b-button>

        <!-- <b-button
          size="md"
          variant="secondary"
          :aria-label="$t('button.common.try_again')"
        >
          {{ $t("button.common.try_again") }}
        </b-button> -->
      </template>
    </b-modal>
  </div>
</template>

<script>
import ax from "@/api/tournament";
import { myMixin } from "@/mixin/myMixin";
import { loadStripe } from "@stripe/stripe-js";
export default {
  name: "TournamentRanking",

  data() {
    return {
      searchData: {
        pageno: parseInt(this.$route.query.page) || 1,
        tournamentno: this.$route.params.id || 0,
        scoretype: this.$route.query.scoretype || 1,
        gender: this.$route.query.gender || 0,
        pagesize: this.$route.query.pagesize || 10,
        tour_rank_type: "1",
      },
      page_total: 1,
      total_cnt: 0,
      data_yn: true,
      rows: 10,
      items: [],
      view_hide: null,
      tournamentinfo: {},

      stripe: null,
      elements: null,
      cardNumber: null,
      cardExpiry: null,
      cardCvc: null,
      postalCode: "",
      couponCode: "",
      product: {},
      coupon: {},
      pay_result: { paymentIntent: {} },
      pay_fail_message: "",
      _stripe: {},
      pay_flag: 1,
      login: sessionStorage.getItem("token") ? true : false,
      paytournamentinfo: {
        player: {},
        tour_results: {},
        tourdefine: {},
        tour_order_list: [],
      },
    };
  },
  watch: {
    "searchData.pageno": function () {
      this.get_tournamentranklist();
    },
    "searchData.pagesize": function () {
      this.searchData.pageno = 1;
      this.get_tournamentranklist();
    },
    "searchData.scoretype": function () {
      this.searchData.pageno = 1;
      this.get_tournamentranklist();
    },
    "searchData.tour_rank_type": function () {
      this.searchData.pageno = 1;
      this.get_tournamentranklist();
    },
    "searchData.gender": function () {
      this.searchData.pageno = 1;
      this.get_tournamentranklist();
    },
  },
  methods: {
    async onModalShown() {
      // 모달이 열리고 나서 mount 실행
      if (!this.stripe) {
        this.stripe = await loadStripe(process.env.VUE_APP_STRIPE_PK);
      }

      this.elements = this.stripe.elements();

      this.cardNumber = this.elements.create("cardNumber");
      this.cardNumber.mount("#card-number-element");

      this.cardExpiry = this.elements.create("cardExpiry");
      this.cardExpiry.mount("#card-expiry-element");

      this.cardCvc = this.elements.create("cardCvc");
      this.cardCvc.mount("#card-cvc-element");
    },

    participation(tour_pk) {
      if (!this.login) {
        this.$bvToast.show("toast-require-login");
        return false;
      }


      this._stripe = {};
      this.stripe = null;
      this.elements = null;

      // 2. 카드 입력 필드 관련 초기화
      this.cardNumber = null;
      this.cardExpiry = null;
      this.cardCvc = null;
      this.postalCode = "";

      // 3. 쿠폰 및 상품 정보 초기화
      this.couponCode = "";
      this.coupon = {};
      this.product = {};

      // 4. 결제 결과 및 플래그 초기화
      this.pay_result = { paymentIntent: {} };
      this.pay_flag = 1;
      this.pay_fail_message = "";

      // 5. 대회 및 사용자 관련 복합 객체 초기화
      this.paytournamentinfo = {
        player: {},
        tour_results: {},
        tourdefine: {},
        tour_order_list: [], // 배열은 빈 배열로
      };

      this.post_stripeinit(tour_pk);
    },

    participation_no() {
      alert(this.$i18n.t("alert.common.offline"));
      return false;
    },

    post_stripeinit(tour_pk) {
      ax.post_stripeinit(tour_pk, (flag, data) => {
        // console.log(flag, data);
        if (flag) {
          this.paytournamentinfo = data.tournamentinfo;
          this.tour_pk = data.tournamentinfo.tourdefine.tour_pk;
          this.product = data.product;

          this.pay_flag = 1;
          this.$bvModal.show("modal-entry-fee-payment");
        } else {
          this.pay_flag = 3;
          this.pay_fail_message = data.message || "";
          this.$bvModal.show("modal-entry-fee-payment");
        }
      });
    },
    async onPaySubmit(event) {
      event.preventDefault();

      const { paymentMethod, error } = await this.stripe.createPaymentMethod({
        type: "card",
        card: this.cardNumber,
        billing_details: { address: { postal_code: this.postalCode } },
      });

      if (error) return alert(error.message);

      ax.post_stripe_confirm(
        this.tour_pk,
        { product_id: this.product.id, paymentmethod_id: paymentMethod.id, coupon_code: this.couponCode },
        async (flag, data) => {
          this._stripe = data.stripe;
          // console.log("this.product", this.product);

          if (flag) {
            this.pay_result = await this.stripe.confirmCardPayment(
              this._stripe.client_secret
            );
            // console.log("this.paymentIntent", this.pay_result.paymentIntent);
            if (this.pay_result.error) {
              alert(this.pay_result.error.message);
            } else if (this.pay_result.paymentIntent.status === "succeeded") {
              const charges = this.pay_result.paymentIntent.charges
                ? this.pay_result.paymentIntent.charges.payment_method_details
                    .card
                : "";
              ax.post_order_insert(
                this.tour_pk,
                {
                  charges: JSON.stringify(charges),
                  payment_intent_id: this.pay_result.paymentIntent.id,

                  product: JSON.stringify({
                    amount: this.product.amount,
                    actual_amount: this.pay_result.paymentIntent.amount,
                    id: this.product.id,
                    name: this.product.name,
                    price_id: this.product.price_id,
                    currency: this.product.currency,
                    coupon_code: this.couponCode,
                  }),
                },
                (flag, data) => {
                  // console.log(flag, data);

                  if (flag) {
                    this.pay_flag = 2;
                  } else {
                    // alert(data.message);
                    this.pay_flag = 3;
                    this.pay_fail_message = data.message || "";
                  }
                }
              );
            }
          } else {
            alert(data.message);
          }
        }
      );
    },
    get_tournamentranklist() {
      ax.get_tournamentranklist(this.searchData, (flag, data) => {
        if (flag) {
          this.total_cnt = data.tournamentranklistcnt;
          this.page_total = Math.ceil(
            data.tournamentranklistcnt / this.searchData.pagesize
          );
          this.items = data.tournamentranklist;
          this.tournamentinfo = data.tournamentinfo;
        } else {
          this.page_total = 0;
          this.data_yn = false;
          this.$notify({
            group: "alert",
            type: "warn",
            text: data,
            duration: 5000,
            speed: 1000,
          });
        }
      });
    },
    onSubmit(event) {
      event.preventDefault();
      this.searchData.pageno = 1;
      this.$router
        .push({
          query: {
            scoretype: this.searchData.scoretype,
            gender: this.searchData.gender,
          },
        })
        .catch(() => {});
    },
    coupon_check(tour_pk) {

      if (this.couponCode === "") {
        alert(
          this.$i18n.t("alert.common.field_enter", {
            field: this.$i18n.t("title.common.coupon"),
          })
        );
        return false;
      }

      ax.post_stripe_coupon(tour_pk, { couponCode: this.couponCode }, (flag, data) => {
        // console.log(flag, data);
        if (flag) {
          this.paytournamentinfo = data.tournamentinfo;
          this.tour_pk = data.tournamentinfo.tourdefine.tour_pk;
          this.product = data.product;
          this.coupon = data.coupon;
          console.log('data.product', data.product);
          // this.pay_flag = 1;
          // this.$bvModal.show("modal-entry-fee-payment");
        } else {
          alert(data.message);
          this.couponCode = "";
          // this.pay_flag = 3;
          // this.pay_fail_message = data.message || "";

          // this.$bvModal.show("modal-entry-fee-payment");
        }
      });

    },
    linkGen(pageNum) {
      return `?page=${pageNum}`;
    },
    toggle_tr(index) {
      if (this.view_hide === index) this.view_hide = null;
      else this.view_hide = index;
    },
    change_type(type) {
      this.searchData.scoretype = type;
      this.searchData.pageno = 1;
      this.view_hide = null;
    },
  },
  created() {
    this.get_tournamentranklist();
  },

  mixins: [myMixin],
};
</script>
<style lang="scss" scoped>
#card-number-element,
#card-expiry-element,
#card-cvc-element {
  border: 1px solid #cdcfd1;
  padding: 10px 10px;
  background-color: #fff;
  height: 40px;
  box-sizing: border-box;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

#card-expiry-element,
#card-cvc-element {
  width: 49%;
}

#card-cvc-element {
  margin-left: 5px;
}
</style>
